import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private ws: PostmethodService) { }

  createLocation(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/location");
  }

  updateLocation(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/location", id);
  }

  getLocation() {
    return this.ws.wsGet(environment.baseUrl + "masters/location");
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getZoneByCountry(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "/common/get-zones-by-country", id);
  }

  getStateByZone(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-states-by-zone", id);
  }

  getRegionByState(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-regions-by-state", id);
  }

  getDistrictByRegion(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-districts-by-region", id);
  }

  getAreaByDistrict(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-areas-by-district", id);
  }

}
